export type FnArgs<Fn> = Fn extends (...args: infer A) => any
  ? A : never;

export class EventUtils {
  filter<Fn extends (...args: any[]) => void>(originFn: Fn, filterFn: (...args: FnArgs<Fn>) => boolean) {
    return (...args: FnArgs<Fn>) => {
      if (filterFn(...args)) {
        return originFn(...args);
      }
    }
  }
}

export const eventUtils = new EventUtils();
